import { render, staticRenderFns } from "./AutocompleteProduct.vue?vue&type=template&id=4a4fc7d2&scoped=true&"
import script from "./AutocompleteProduct.vue?vue&type=script&lang=ts&"
export * from "./AutocompleteProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4fc7d2",
  null
  
)

export default component.exports